import { AuthService } from "@/services";
import { i18n } from "@/setup/i18n-setup";
import Vue from "vue";
import { ConfirmResult } from "winfakt-vue-components";

interface IPendingChangesExtraOptions {
	warningText?:() => string;
	warningTextString?: string;
}

function getDefaultOptions():IPendingChangesExtraOptions {
	return {
		warningText():string {
			return "WARNING! CHANGES PENDING!";
		}
	};
}

export class PendingChangesNotifier {
	changesPending:boolean = false;
	options:IPendingChangesExtraOptions;

	constructor(private vue:Vue, watchKey:string, extraOptions:IPendingChangesExtraOptions = getDefaultOptions()) {
		requestAnimationFrame(() => {
			vue.$watch(watchKey, (n, o) => {
				this.changesPending = true;
			}, {
				deep: true
			});
		});
		this.options = {...getDefaultOptions(), ...extraOptions};
	}


	private getWarningText():string {
		if (this.options.warningTextString) {
			return this.options.warningTextString;
		}
		if (this.options.warningText) {
			return this.options.warningText();
		}
		return "";
	}

	async askToSave():Promise<ConfirmResult>{
		if (!AuthService.isLoggedIn) {
			return ConfirmResult.NO;
		}
		if (this.changesPending) {
			let text = this.getWarningText();
			let result = await this.vue.$wf.confirm(text, i18n.t("common.yes"),  i18n.t("common.no"), i18n.t("common.attention"), "primary", i18n.t("common.cancel"));
			return result;
		}
		return ConfirmResult.NO;
	}

	showWarning(){
		this.vue.$wf.confirm(this.getWarningText(), i18n.t("common.yes"),  i18n.t("common.no"), i18n.t("common.attention"), "primary", i18n.t("common.cancel"));
	}
}